import { useMemo } from "react";
import { useIntl } from "react-intl";
import {
    ButtomMenuButton,
    LabelKeyValueItem,
    ParagraphButtonData,
    ParagraphButtonDataType
} from "@/model";
import { getLabelKeyFromValue } from "@/util/typeUtil";
import { DropdownGroup, DropdownButton, DropdownItem, DropdownItems } from "@/component/input";


const BREAKPOINT_WIDTH = 130;

const BUTTON_TYPE_OPTIONS: LabelKeyValueItem<ParagraphButtonDataType>[] = [
    { labelKey: "i04014", value: "text" },
    { labelKey: "i04015", value: "next" },
    { labelKey: "i04016", value: "link" },
    { labelKey: "i04017", value: "back" },
    { labelKey: "i04018", value: "scenario" },
    { labelKey: "i04078", value: "intent" }
];
const BUTTON_TYPE_OPTIONS_SM: LabelKeyValueItem<ParagraphButtonDataType>[] = [
    { labelKey: "i04014", value: "text" },
    { labelKey: "i04015", value: "next" },
    { labelKey: "i04016", value: "link" },
    { labelKey: "i04017_1", value: "back" },
    { labelKey: "i04018_1", value: "scenario" },
    { labelKey: "i04078", value: "intent" }
];

interface ButtonTypeDropdownProps<T extends ParagraphButtonData | ButtomMenuButton> {
    width: number;
    disabled?: boolean;
    button: T;
    options?: ParagraphButtonDataType[];
    onChange: (button: T) => void;
}

const ButtonTypeDropdown = <T extends ParagraphButtonData | ButtomMenuButton>(props: ButtonTypeDropdownProps<T>) => {
    const { width, disabled = false, button, onChange, options = ['text', 'next', 'link', 'back', 'scenario'] } = props;

    const intl = useIntl();

    const dropdownOptions = useMemo(() => {
        return width < BREAKPOINT_WIDTH ? BUTTON_TYPE_OPTIONS_SM : BUTTON_TYPE_OPTIONS;
    }, [width]);

    const typeOptions = useMemo(() => {
        return dropdownOptions.filter(option => options.includes(option.value));
    }, [dropdownOptions, options]);

    return (
        <DropdownGroup width={width}>{({ open, close }) => (<>
            <DropdownButton open={open} close={close} disabled={disabled}>
                {intl.formatMessage({ id: getLabelKeyFromValue(dropdownOptions, button.button_type ?? typeOptions[0].value) })}
            </DropdownButton>
            <DropdownItems>
                {typeOptions.map(option => (
                    <DropdownItem key={option.value}
                                  onClick={() => onChange({ ...button, button_type: option.value })}
                    >
                        {intl.formatMessage({ id: option.labelKey })}
                    </DropdownItem>
                ))}
            </DropdownItems>
        </>)}</DropdownGroup>
    );
};

export default ButtonTypeDropdown;
